import { parseISO } from 'date-fns';

enum TransactionStatus {
  PAID = 'paid',
  PROCESSING = 'processing',
  FAILED = 'failed',
}

export interface ICreditCardTransaction {
  id: number;
  order_id: number;
  credit_card_id: number;
  external_transaction_id: string;
  status_code: number;
  message: string;
  status: string;
  created_at: string;
  updated_at: string;
  credit_card_last_digits: string;
  credit_card_brand: string;
}

export class CreditCardTransaction {
  id: number;
  order_id: number;
  credit_card_id: number;
  external_transaction_id: string;
  status_code: number;
  message: string;
  status: TransactionStatus;
  created_at: Date;
  updated_at: Date;
  credit_card_last_digits: string;
  credit_card_brand: string;
  success: boolean;

  constructor(data: ICreditCardTransaction) {
    this.id = data.id;
    this.order_id = data.order_id;
    this.credit_card_id = data.credit_card_id;
    this.external_transaction_id = data.external_transaction_id;
    this.status_code = data.status_code;
    this.message = data.message;
    this.status = data.status as TransactionStatus;
    this.created_at = parseISO(data.created_at);
    this.updated_at = parseISO(data.updated_at);
    this.credit_card_last_digits = data.credit_card_last_digits;
    this.credit_card_brand = data.credit_card_brand;
    this.success = this.status === TransactionStatus.PAID;
  }
}
